module.exports = "<h1 mat-dialog-title>{{'igo.userButton.infoTitle' | translate}}</h1>\r\n<div mat-dialog-content>\r\n  <p>{{'igo.userButton.dialog.user' | translate}}: {{user.sourceId}}</p>\r\n  <p>{{'igo.userButton.dialog.email' | translate}}: {{user.email}}</p>\r\n  <p>{{'igo.userButton.dialog.expiration' | translate}}: {{exp}}</p>\r\n</div>\r\n<div mat-dialog-actions style=\"justify-content: center\">\r\n  <button mat-button color=\"primary\"\r\n         (click)=\"dialogRef.close(false)\">\r\n    OK\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/map/user-button/user-dialog.component.html
// module id = 910
// module chunks = 0